import type { FrontendConfig } from "@smartrr/shared/interfaces/FrontendConfig";

const config: FrontendConfig = window.__SmartrrConfig__;
export default config;
